module.exports = __webpack_public_path__ + "img/4-2.5f6ab63d.png";